import { useEffect, useReducer, useState } from "react";
import { useDispatch } from "react-redux";
import { DateFilter } from "../../components/DateFilter";
import { driverService } from "../../Services/driver.service";
import { toDate } from "../../Services/string.service";
import { ToastComponent } from "../Components/ToastComponent";
import { useTranslation } from "react-i18next";

export default function DriverRegister(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  dispatch({ type: "title", value: t("TITLE.DRIVER_REGISTER") });

  const [licenseExpiration, setLicenseExpiration] = useState(
    toDate(props.driver?.licenseExpiration) ?? new Date()
  );
  const [birthDate, setBirthDate] = useState(
    toDate(props.driver?.birthDate) ?? new Date()
  );

  const formInitialValues = {
    driverId: props.driver?.driverId ?? 0,
    name: props.driver?.name ?? "",
    document: props.driver?.document ?? "",
    functionalRegistry: props.driver?.functionalRegistry ?? "",
    iButtonKey: props.driver?.iButtonKey ?? "",
    licenseNumber: props.driver?.licenseNumber ?? "",
    licenseCategory: props.driver?.licenseCategory ?? "",
    mobilePhone: props.driver?.mobilePhone ?? "",
  };

  const formReducer = (state, event) => {
    if (event.reset) {
      return formInitialValues;
    }
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  useEffect(() => {
    setFormData({ reset: true });
  }, [props]);

  const [formData, setFormData] = useReducer(formReducer, {});
  const [toastParams, setToastParams] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onSaveDriver = () => {
    try {
      setIsLoading(true);

      const formattedPayload = {
        ...formData,
        licenseExpiration: licenseExpiration,
        birthDate: birthDate,
      };

      props.driver?.driverId && props.driver?.driverId != 0
        ? driverService.updateDriver(formattedPayload)
        : driverService.createDriver(formattedPayload);
    } catch (error) {
      setToastParams(
        JSON.stringify({
          show: true,
          title: t("COMMON.ERROR"),
          body: t("ERRORS.SAVE_DRIVER_ERROR"),
          color: "Danger",
        })
      );
    } finally {
      setIsLoading(false);
      props.handleClose();
    }
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  return (
    <div className="card mb-4">
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <h5 className="card-header">{t("DRIVER.REGISTER")}</h5>
      <div className="card-header">
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.NAME")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="name"
              placeholder={t("DRIVER.NAME")}
              value={formData.name ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.DOCUMENT")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="document"
              placeholder={t("DRIVER.DOCUMENT")}
              value={formData.document ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.RE")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="functionalRegistry"
              placeholder={t("DRIVER.RE")}
              value={formData.functionalRegistry ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.IBUTTON_KEY")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="iButtonKey"
              placeholder="iButton"
              value={formData.iButtonKey ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.CNH")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="licenseNumber"
              placeholder={t("DRIVER.CNH")}
              value={formData.licenseNumber ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.CNH_CATEGORY")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="licenseCategory"
              placeholder={t("DRIVER.CNH_CATEGORY")}
              value={formData.licenseCategory ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.CELL_PHONE")}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="mobilePhone"
              placeholder={t("DRIVER.CELL_PHONE")}
              value={formData.mobilePhone ?? ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.LICENSE_EXPIRATION")}
          </label>
          <div className="col-sm-10">
            <DateFilter
              id="licenseExpiration"
              title={t("DRIVER.EXPIRATION")}
              value={licenseExpiration}
              handleCallback={setLicenseExpiration}
              placeholder={t("COMMON.DATE")}
            />
          </div>
        </div>
        <div className="row mb-3">
          <label
            className="col-sm-2 col-form-label"
            htmlFor="basic-default-name"
          >
            {t("DRIVER.BIRTH_DATE")}
          </label>
          <div className="col-sm-10">
            <DateFilter
              id="birthDate"
              title={t("DRIVER.BIRTH")}
              value={birthDate}
              handleCallback={setBirthDate}
              placeholder={t("COMMON.DATE")}
            />
          </div>
        </div>

        <div className="row justify-content-end" style={{ textAlign: "end" }}>
          <div className="col-lg-12 col-md-12 col-xs-12 d-flex flex-wrap justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-warning"
              onClick={props.handleClose}
            >
              {t("BUTTONS.CLOSE")}
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={onSaveDriver}
              disabled={isLoading}
            >
              {t("BUTTONS.SAVE")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}